import { supabase } from "@/integrations/supabase/client";

/**
 * Resolve a harvested part to a configured spare part type using the
 * name/alias resolver in the database. Tries the sheet's part category
 * first (it mirrors the configured catalogue wording), then the part name.
 * Never throws — an unresolved part is simply stored uncategorised.
 */
export async function resolvePartTypeId(
  name: string | null | undefined,
  brand?: string | null,
  categoryHint?: string | null,
): Promise<string | null> {
  const candidates = [categoryHint, name]
    .map((v) => (v ?? "").trim())
    .filter((v) => v.length > 0 && v.toLowerCase() !== "unknown");

  for (const candidate of candidates) {
    try {
      const { data, error } = await (supabase as any).rpc("resolve_spare_part_type", {
        _name: candidate,
        _brand: brand || null,
      });
      if (error) continue;
      if (data) return data as string;
    } catch {
      // ignore — resolution is best effort
    }
  }
  return null;
}
